<template>
  <div class="tab-instruction">
    <el-row>
      <el-button :disabled="readOnly" type="primary" @click="handleAdd('detailItemList')">新增</el-button>
      <el-button :disabled="readOnly" type="warning" @click="handleDelete('detailItemList')">删除</el-button>
    </el-row>

    <el-row>
      <el-table
        :data="info.detailItemList"
        style="margin-top: 10px"
        border
        @select="handleSelectItem"
        stripe
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="materialCode"
          label="图片"
          :min-width="100"
        >
          <template slot-scope="scope">
            <el-row>
              <img class="tab-instruction__img" :src="scope.row.imgUrl | parseImgUrlToken" alt />
            </el-row>
            <el-row v-if="!readOnly">
              <el-col :span="12" v-if="!scope.row.imgUrl">
                <upload-file :autoUpload="false" v-model="scope.row.imgUrl" :uploadData="uploadData" btn-text="上传图片">上传图片</upload-file>
              </el-col>
              <el-col :span="12" v-else>
                <span @click="handleItemDelete(scope.row)">删除</span>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="usedPosition"
          label="图片位置"
          :min-width="60"
        >
          <template slot-scope="scope">
            <base-select
              :read-only="readOnly"
              v-model="scope.row.usedPosition"
              apiName="POST_SPS_SYS_ENUM_URL"
              :params="{typeCode: 'TecDocImg'}"
              label
            ></base-select>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="site"
          label="部位"
          :min-width="150"
        >
          <template slot-scope="scope">
            <base-string v-model="scope.row.site" :read-only="readOnly"></base-string>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="methodRemark"
          label="工艺做法"
          :min-width="150"
        >
          <template slot-scope="scope">
            <div class="tab-instruction__methodRemark">{{scope.row.methodRemark}}</div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="materialDescCn"
          label="修改工艺做法"
          :min-width="80"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              :disabled="readOnly"
              @click="handleEditRow(true, scope.row)"
            >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog title="更新企业名称" :visible.sync="dialogConfig.isShow" size="large">
      <el-row>
        <el-col :span="24">
          <base-string label="工艺做法" type="textarea" :rows="10" v-model="dialogConfig.methodRemark"></base-string>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleEditRow(false)">取 消</el-button>
        <el-button type="primary" @click="handleDialogSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import uploadFile from "components/base-control/upload-file.vue";
import { mixins } from "./mixins";
import { parseImgUrlToken } from "src/filter/modules/img";
export default {
  name: "tab-instruction",
  filters: {
    parseImgUrlToken
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixins],
  components: {
    uploadFile
  },
  computed: {},
  methods: {
    handleEditRow(isShow, row) {
      if (isShow === true) {
        this.dialogConfig.selectRow = row;
        this.dialogConfig.methodRemark = row.methodRemark;
      } else {
        this.dialogConfig.selectRow = "";
        this.dialogConfig.selectRow = {};
      }
      this.dialogConfig.isShow = isShow;
    },
    handleDialogSure() {
      this.dialogConfig.selectRow.methodRemark = this.dialogConfig.methodRemark;
      this.handleEditRow(false);
    },
    handleItemDelete(row) {
      row.imgUrl = "";
    }
  },
  mounted() {},
  data() {
    return {
      dialogConfig: {
        isShow: false,
        selectRow: {},
        methodRemark: ""
      },
      labelConfig: {
        readOnly: false
      },
      selectList: [],
      uploadData: {
        module: 'instruction',
        userId: this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.adminUserName
      }
    };
  }
};
</script>

<style scoped>
.tab-instruction__img {
  width: 100%;
}
.tab-instruction__methodRemark {
  white-space: pre-line;
}
</style>
